import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c313eca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-sport-preferences" }
const _hoisted_2 = {
  key: 0,
  class: "responsive-table"
}
const _hoisted_3 = { class: "mobile-display" }
const _hoisted_4 = {
  key: 0,
  class: "profile-buttons mobile-display"
}
const _hoisted_5 = {
  key: 1,
  class: "profile-buttons"
}
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "cell-heading" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "cell-heading" }
const _hoisted_11 = {
  key: 0,
  class: "disabled-message"
}
const _hoisted_12 = {
  key: 1,
  class: "fa fa-refresh fa-spin fa-fw"
}
const _hoisted_13 = { class: "cell-heading" }
const _hoisted_14 = { class: "cell-heading" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = { class: "cell-heading" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "action-buttons"
}
const _hoisted_20 = { class: "cell-heading" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "edition-buttons"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "profile-buttons"
}
const _hoisted_26 = {
  key: 1,
  class: "profile-buttons"
}

import { ComputedRef, computed, inject, reactive, toRefs, watch } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { AUTH_USER_STORE, ROOT_STORE, SPORTS_STORE } from '@/store/constants'
  import { ISport, ITranslatedSport } from '@/types/sports'
  import { IUserProfile, IUserSportPreferencesPayload } from '@/types/user'
  import { useStore } from '@/use/useStore'
  import { translateSports } from '@/utils/sports'

  interface Props {
    user: IUserProfile
    isEdition: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    isEdition: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
    isEdition: boolean
  }

  

  const store = useStore()
  const { t } = useI18n()

  const { isEdition, user } = toRefs(props)
  const sportColors = inject('sportColors')
  const sports: ComputedRef<ISport[]> = computed(
    () => store.getters[SPORTS_STORE.GETTERS.SPORTS]
  )
  const translatedSports: ComputedRef<ITranslatedSport[]> = computed(() =>
    translateSports(sports.value, t, true, user.value.sports_list)
  )
  const loading = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.USER_LOADING]
  )
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  const sportPayload: IUserSportPreferencesPayload = reactive({
    sport_id: 0,
    color: null,
    is_active: true,
    stopped_speed_threshold: 1,
  })

  function updateSportInEdition(sport: ISport | null) {
    if (sport !== null) {
      sportPayload.sport_id = sport.id
      sportPayload.color = sport.color ? sport.color : sportColors[sport.label]
      sportPayload.is_active = sport.is_active_for_user
      sportPayload.stopped_speed_threshold = sport.stopped_speed_threshold
    } else {
      resetSportPayload()
    }
  }
  function isSportInEdition(sportId: number) {
    return sportPayload.sport_id === sportId
  }
  function updateColor(event: Event & { target: HTMLInputElement }) {
    sportPayload.color = event.target.value
  }
  function updateThreshold(event: Event & { target: HTMLInputElement }) {
    sportPayload.stopped_speed_threshold = parseFloat(event.target.value)
  }
  function updateIsActive(event: Event & { target: HTMLInputElement }) {
    sportPayload.is_active = event.target.checked
  }
  function resetSportPayload() {
    sportPayload.sport_id = 0
    sportPayload.color = null
    sportPayload.is_active = true
    sportPayload.stopped_speed_threshold = 1
    store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES)
  }
  function updateSport(event: Event) {
    event.preventDefault()
    store.dispatch(
      AUTH_USER_STORE.ACTIONS.UPDATE_USER_SPORT_PREFERENCES,
      sportPayload
    )
  }

  watch(
    () => loading.value,
    (newIsLoading) => {
      if (!newIsLoading && !errorMessages.value) {
        resetSportPayload()
      }
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_SportImage = _resolveComponent("SportImage")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(sports).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(isEdition))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "cancel",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push('/profile/sports')), ["prevent"]))
                  }, _toDisplayString(_ctx.$t('buttons.BACK')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/profile/edit/sports')))
                  }, _toDisplayString(_ctx.$t('user.PROFILE.EDIT_SPORTS_PREFERENCES')), 1),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/')))
                  }, _toDisplayString(_ctx.$t('common.HOME')), 1)
                ]))
          ]),
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.COLOR')), 1),
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('workouts.SPORT', 0)), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('workouts.WORKOUT', 0)), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.IS_ACTIVE')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.STOPPED_SPEED_THRESHOLD')), 1),
                (_unref(isEdition))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.ACTION')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(translatedSports), (sport) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: sport.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.COLOR')), 1),
                    (isSportInEdition(sport.id))
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          class: "sport-color",
                          type: "color",
                          value: _unref(sportPayload).color,
                          onInput: updateColor
                        }, null, 40, _hoisted_9))
                      : (_openBlock(), _createBlock(_component_SportImage, {
                          key: 1,
                          title: sport.translatedLabel,
                          "sport-label": sport.label,
                          color: sport.color ? sport.color : _unref(sportColors)[sport.label]
                        }, null, 8, ["title", "sport-label", "color"]))
                  ]),
                  _createElementVNode("td", {
                    class: _normalizeClass(["sport-label", { 'disabled-sport': !sport.is_active }])
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.LABEL')), 1),
                    _createTextVNode(" " + _toDisplayString(sport.translatedLabel) + " ", 1),
                    (!sport.is_active)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " (" + _toDisplayString(_ctx.$t('user.PROFILE.SPORT.DISABLED_BY_ADMIN')) + ") ", 1))
                      : _createCommentVNode("", true),
                    (_unref(loading) && isSportInEdition(sport.id))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                      : _createCommentVNode("", true),
                    (_unref(errorMessages) && _unref(sportPayload).sport_id === sport.id)
                      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                          key: 2,
                          message: _unref(errorMessages)
                        }, null, 8, ["message"]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-center", { 'disabled-sport': !sport.is_active }])
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('workouts.WORKOUT', 0)), 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(`fa fa${
                  _unref(user).sports_list.includes(sport.id) ? '-check' : ''
                }`),
                      "aria-hidden": "true"
                    }, null, 2)
                  ], 2),
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-center", { 'disabled-sport': !sport.is_active }])
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.IS_ACTIVE')), 1),
                    (isSportInEdition(sport.id) && sport.is_active)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          checked: sport.is_active_for_user,
                          onChange: updateIsActive
                        }, null, 40, _hoisted_15))
                      : (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: _normalizeClass(`fa fa${sport.is_active_for_user ? '-check' : ''}`),
                          "aria-hidden": "true"
                        }, null, 2))
                  ], 2),
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-center", { 'disabled-sport': !sport.is_active }])
                  }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.STOPPED_SPEED_THRESHOLD')), 1),
                    (isSportInEdition(sport.id) && sport.is_active)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          class: "threshold-input",
                          type: "number",
                          min: "0",
                          step: "0.1",
                          value: _unref(sportPayload).stopped_speed_threshold,
                          onInput: updateThreshold
                        }, null, 40, _hoisted_17))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(sport.stopped_speed_threshold), 1))
                  ], 2),
                  (_unref(isEdition))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('user.PROFILE.SPORT.ACTION')), 1),
                        (_unref(sportPayload).sport_id === 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (updateSportInEdition(sport))
                            }, _toDisplayString(_ctx.$t('buttons.EDIT')), 9, _hoisted_21))
                          : _createCommentVNode("", true),
                        (isSportInEdition(sport.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("button", {
                                disabled: _unref(loading),
                                onClick: updateSport
                              }, _toDisplayString(_ctx.$t('buttons.SUBMIT')), 9, _hoisted_23),
                              _createElementVNode("button", {
                                disabled: _unref(loading),
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (updateSportInEdition(null)))
                              }, _toDisplayString(_ctx.$t('buttons.CANCEL')), 9, _hoisted_24)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          (_unref(isEdition))
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("button", {
                  class: "cancel",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$router.push('/profile/sports')), ["prevent"]))
                }, _toDisplayString(_ctx.$t('buttons.BACK')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/profile/edit/sports')))
                }, _toDisplayString(_ctx.$t('user.PROFILE.EDIT_SPORTS_PREFERENCES')), 1),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/')))
                }, _toDisplayString(_ctx.$t('common.HOME')), 1)
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})